import React, { useState } from "react";
import { getOrderTrackingById } from "../../../services/apiService";
import ReactDOM from "react-dom";
import {
  FaFileAlt,
  FaBox,
  FaTruck,
  FaShippingFast,
  FaCheckCircle,
} from "react-icons/fa";

const TelecallingOrderTracking = () => {
  const [orderId, setOrderId] = useState("");
  const [orderData, setOrderData] = useState([]);
  const [showItemsModal, setShowItemsModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [hdr, setHdr] = useState({});
  const [bill, setBill] = useState({});
  const [ship, setShip] = useState({});
  const [data, setdata] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const handleSearch = async () => {
    if (!orderId) {
      alert("Please enter Order ID");
      return;
    }

    try {
      const res = await getOrderTrackingById(orderId);
      setOrderData(res.data || []);
      setPage(1);
    } catch (error) {
      alert("Order not found");
    }
  };

  const totalPages = Math.ceil(orderData.length / pageSize);
  const startIndex = (page - 1) * pageSize;
  const paginatedOrders = orderData.slice(startIndex, startIndex + pageSize);

  const handlePrintInvoice = () => {
    if (!selectedOrder) {
      alert("No order selected");
      return;
    }

    const printWindow = window.open("", "_blank", "width=900,height=900");

    if (!printWindow) return;

    printWindow.document.open();

    printWindow.document.write(
      generateInvoiceHTML(
        selectedOrder,
        selectedOrder?.details || [],
        selectedOrder,
        selectedOrder?.shiping || {},
        {},
      ),
    );

    printWindow.document.close();

    printWindow.onload = function () {
      printWindow.print();
    };
  };

  const generateInvoiceHTML = (
    hdr = {},
    orderDetail = [],
    billing,
    shiping,
    details = {},
  ) => {
    const header = hdr?.[0] || {};

    const paidItems = orderDetail.filter((d) => d.type === "r");

    const totalCgst = paidItems.reduce(
      (sum, d) => sum + Number(d.cgstamount || 0),
      0,
    );

    const totalSgst = paidItems.reduce(
      (sum, d) => sum + Number(d.sgstamount || 0),
      0,
    );

    const totalIgst = paidItems.reduce(
      (sum, d) => sum + Number(d.igstamount || 0),
      0,
    );

    /* ✅ ITEMS FIXED HERE */

    const rows = orderDetail
      .map((item, index) => {
        const products = item?.products || item?.Products || [];

        if (!Array.isArray(products)) return "";

        return products
          .map(
            (sub) => `

<tr>

<td>${index + 1}</td>

<td>${sub?.hsn || 804561}</td>

<td style="text-align:left;">

${sub?.modelno || "-"}

${sub?.mainmodelno && sub.mainmodelno !== "--" ? "," + sub.mainmodelno : ""}

</td>

<td>${item?.orderqty || 0}</td>

<td>PCS</td>

<td>${item?.type === "r" ? sub?.mrp || 0 : 0}

</td>

<td>${item?.dispercent || 0}%</td>

<td>${item?.sdispercent || 0}%</td>

<td>${item?.exdispercent || 0}%</td>


<td>

${item?.orderqty ? Number(item.totalamount / item.orderqty).toFixed(2) : "0.00"}

</td>


<td>

${
  item?.igst > 0
    ? item?.igst
    : Number(item?.cgst || 0) + Number(item?.sgst || 0)
}

%

</td>


<td>

₹${Number(item?.totalamount || 0).toFixed(2)}

</td>


</tr>

`,
          )
          .join("");
      })
      .join("");

    return `
<!DOCTYPE html>

<html>

<head>

<title>Invoice - ${hdr?.orderid}</title>

<style>

body{
font-family:Arial;
padding:20px;
color:#000;
}

.container{
max-width:950px;
margin:auto;
border:2px solid #000;
padding:15px;
box-sizing:border-box;
}

h2,h3{
text-align:center;
margin:2px 0;
font-weight:bold;
}

.row{
display:flex;
justify-content:space-between;
font-size:12px;
margin:10px 0;
}

.row div{
width:48%;
padding:8px;
border:1px solid #000;
box-sizing:border-box;
line-height:1.3;
}

table{
width:100%;
border-collapse:collapse;
font-size:12px;
margin-top:10px;
}

th,td{
border:1px solid #ccc;
padding:6px;
text-align:center;
}

th{
background:#f1f1f1;
}

td:nth-child(3){
text-align:left;
}

.summary-grid{
display:flex;
margin-top:15px;
border:1px solid #000;
font-size:12px;
}

.summary-grid div{
flex:1;
border-right:1px solid #000;
padding:8px;
text-align:center;
}

.summary-grid div:last-child{
border-right:none;
font-weight:bold;
}

.bank,.terms{
border:1px solid #000;
padding:10px;
font-size:12px;
margin-top:10px;
}

.signature{
text-align:right;
margin-top:30px;
font-weight:bold;
}

.label{
display:inline-block;
width:160px;
font-weight:bold;
}

</style>

</head>

<body>

<div class="container">


<h3>

${hdr?.orderstatus !== "Cancel" ? "TAX INVOICE" : "CANCELLED INVOICE"}

</h3>



<h2>PIXELED INDIA PVT LTD.</h2>




    <div class="row">
<div>

<span class="label">Customer Name:</span> 
${shiping?.[0]?.name || "-"}<br/>

<span class="label">Mobile No:</span> 
${shiping?.[0]?.phone || "-"}<br/>

<span class="label">PAN:</span> -<br/>

<span class="label">GSTIN:</span> 
${shiping?.[0]?.gstno || "-"}<br/>

<span class="label">Address:</span> 
${shiping?.[0]?.flathouse || shiping?.flathouse || "-"}, 
${shiping?.[0]?.area || shiping?.area || "-"}<br/>

<span class="label">Land Mark:</span> 
${shiping?.[0]?.landmark || shiping?.landmark || "-"}<br/>

<span class="label">City:</span> 
${shiping?.[0]?.city || shiping?.city || "-"}<br/>

<span class="label">State & Pincode:</span> 
${shiping?.[0]?.state || shiping?.state || "-"}, 
${shiping?.[0]?.pincode || shiping?.pincode || "-"}

</div>

  <div>
    <span class="label">Invoice No:</span> ${hdr?.finvvoucher || "Not Generated Yet"}<br/>
    <span class="label">Date:</span> ${hdr?.orderdate ? new Date(hdr.orderdate).toLocaleDateString() : "-"}<br/>
    <span class="label">Vehicle No:</span> ${hdr?.vehicleno || "-"}<br/>
    <span class="label">Transport Name:</span> ${hdr?.transport || "No Transport Yet"}<br/>
    <span class="label">Order No:</span> ${hdr?.orderid || "-"}<br/>
    <span class="label">Order Date:</span> ${hdr?.orderdate ? new Date(hdr.orderdate).toLocaleDateString() : "-"}<br/>
    <span class="label">LR No:</span> ${hdr?.dispatchid || "Dispatched"}<br/>
    <span class="label">No of Cartons:</span> ${hdr?.noofcartoon || 0}
  </div>
</div>



<table>

<thead>

<tr>

<th>S No</th>

<th>HSN</th>

<th>Item Name</th>

<th>Qty</th>

<th>Unit</th>

<th>Mrp</th>

<th>Dis%</th>

<th>S.D%</th>

<th>E.D%</th>

<th>Net Rate</th>

<th>GST%</th>

<th>Amount</th>

</tr>

</thead>


<tbody>

${
  rows ||
  `<tr>
<td colspan="12">
No Items Found
</td>
</tr>`
}

</tbody>


</table>




<div class="summary-grid">


<div>

Taxable Amount

<br>

₹${Number(Number(hdr?.amount || 0) - Number(hdr?.delivarycharges || 0)).toFixed(
      2,
    )}

</div>
 ${
   totalIgst > 0
     ? `
      <div>
        IGST Amount<br/>
        ₹${totalIgst.toFixed(2)}
      </div>
    `
     : `
      <div>
        CGST Amount<br/>
        ₹${totalCgst.toFixed(2)}
      </div>
      <div>
        SGST Amount<br/>
        ₹${totalSgst.toFixed(2)}
      </div>
    `
 }





<div>

Coupon Amount

<br>

₹${Number(hdr?.couponamount || 0).toFixed(2)}

</div>



<div>

Wallet Amount

<br>

₹${Number(hdr?.wallet || 0).toFixed(2)}

</div>



<div>

Delivery Charges

<br>

₹${Number(hdr?.delivarycharges || 0).toFixed(2)}

</div>



<div>

Net Amount

<br>

<b>

₹${Number(hdr?.netamount || 0).toFixed(2)}

</b>

</div>



</div>



</div>


<script>

window.onload=function(){

window.print();

}

</script>


</body>

</html>

`;
  };

  return (
    <div className="tracking-wrapper">
      <h3 className="title">Order Tracking</h3>

      <div className="search-box">
        <input
          type="text"
          placeholder="Enter Order ID"
          value={orderId}
          onChange={(e) => setOrderId(e.target.value)}
        />
        <button onClick={handleSearch}>Search</button>
      </div>

      {orderData.length > 0 && (
        <table className="tracking-table">
          <thead>
            <tr>
              <th>Order ID</th>
              <th>Ordered Date</th>
              <th>Packing Date</th>
              <th>Dispatch Date</th>
              <th>Delivery Date</th>
              <th>Ordered Items</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {paginatedOrders.map((item, index) => (
              <tr key={index}>
                <td>{item.orderid}</td>
                <td>{new Date(item.orderdate).toLocaleDateString("en-IN")}</td>
                <td>{item.packingdate || "Not yet"}</td>
                <td>{item.dispatchdate || "Not yet"}</td>
                <td>{item.deliverydate || "Not yet"}</td>
                <td
                  className="view-link"
                  onClick={() => {
                    setSelectedOrder(item);
                    setShowItemsModal(true);
                  }}
                >
                  View Ordered Items
                </td>
                <td>{item.orderstatus}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {orderData.length > 0 && (
        <div className="pagination-container">
          <div className="pagination-info">
            <span>Items per page:</span>
            <select
              value={pageSize}
              onChange={(e) => {
                setPageSize(Number(e.target.value));
                setPage(1);
              }}
            >
              {[5, 10, 20, 50].map((n) => (
                <option key={n} value={n}>
                  {n}
                </option>
              ))}
            </select>
            <span>
              Showing {orderData.length > 0 ? startIndex + 1 : 0}-
              {Math.min(startIndex + pageSize, orderData.length)} of{" "}
              {orderData.length}
            </span>
          </div>
          <div className="page-buttons">
            <button
              className="page-btn"
              disabled={page === 1}
              onClick={() => setPage(page - 1)}
            >
              Previous
            </button>
            <span className="page-count">
              {page} / {totalPages || 1}
            </span>
            <button
              className="page-btn"
              disabled={page === totalPages || totalPages === 0}
              onClick={() => setPage(page + 1)}
            >
              Next
            </button>
          </div>
        </div>
      )}

      {showItemsModal &&
        selectedOrder &&
        ReactDOM.createPortal(
          <div className="modal-overlay">
            <div className="modal-box">
              <div className="modal-header">
                <h3>Order Items – {selectedOrder.orderid}</h3>
                <button onClick={() => setShowItemsModal(false)}>✖</button>
              </div>

              <div className="modal-body">
                <table className="items-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Product</th>
                      <th>Qty</th>
                      <th>Mrp</th>
                      <th>GST</th>
                      <th>Rate</th>
                      <th>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedOrder.details.map((d, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{d.products?.[0]?.modelno || "N/A"}</td>
                        <td>{d.orderqty}</td>
                        <td>₹{Number(d.mrp || 0).toFixed(2)}</td>
                        <td>₹{Number(d.gstamount || 0).toFixed(2)}</td>
                        <td>
                          ₹{" "}
                          {Number(d.products?.[0]?.netrate || d.netrate || 0) >
                          0
                            ? Number(
                                d.products?.[0]?.netrate || d.netrate,
                              ).toFixed(2)
                            : (
                                Number(d.mrp || d.products?.[0]?.mrp || 0) -
                                (Number(d.mrp || d.products?.[0]?.mrp || 0) *
                                  Number(
                                    d.dispercent ??
                                      d.products?.[0]?.discount ??
                                      0,
                                  )) /
                                  100
                              ).toFixed(2)}
                        </td>
                        <td>₹ {Number(d?.totalamount || 0).toFixed(2)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                {/* BILLING SUMMARY */}
                {/* <div className="billing-card">
        <div className="bill-row">
          <span>Without GST Amount</span>
          <span>₹{selectedOrder.total - selectedOrder.gstamount}</span>
        </div>

        <div className="bill-row">
          <span>Total GST</span>
          <span>₹{selectedOrder.gstamount}</span>
        </div>

        <div className="bill-row">
          <span>Delivery Charges</span>
          <span>₹{selectedOrder.delivarycharges || 0}</span>
        </div>

        <div className="bill-row discount1">
          <span>Discount</span>
          <span>-₹{selectedOrder.discount}</span>
        </div>

        <div className="bill-row grand">
          <span>Grand Total</span>
          <span>₹{selectedOrder.netamount}</span>
        </div>
      </div> */}

                {/* ORDER DATE */}
                <div className="order-meta">
                  Order Date:{" "}
                  {new Date(selectedOrder.orderdate).toLocaleString()}
                </div>

                {/* ORDER TRACKER */}
                <div className="order-tracker">
                  {[
                    { key: "Success", label: "Order Placed" },
                    { key: "packed", label: "Packing" },
                    { key: "dispatched", label: "Dispatched" },
                    { key: "transit", label: "In Transit" },
                    { key: "delivered", label: "Delivered" },
                  ].map((step) => (
                    <div
                      key={step.key}
                      className={`tracker-step ${
                        selectedOrder.orderstatus === step.key ||
                        selectedOrder.completedSteps?.includes(step.key)
                          ? "active"
                          : ""
                      }`}
                    >
                      <div className="circle">
                        {selectedOrder.completedSteps?.includes(step.key)
                          ? "✓"
                          : ""}
                      </div>
                      <p>{step.label}</p>
                    </div>
                  ))}
                </div>

                {/* DOWNLOAD BUTTON */}
                <div style={{ textAlign: "right", marginTop: "20px" }}>
                  <button
                    onClick={handlePrintInvoice}
                    style={{
                      background: "#005487",
                      color: "#fff",
                      border: "none",
                      padding: "8px 20px",
                      borderRadius: "6px",
                      cursor: "pointer",
                    }}
                  >
                    Download Invoice
                  </button>
                </div>
              </div>
            </div>
          </div>,
          document.body,
        )}
      <style>{`
        .tracking-wrapper {
          background: #fff;
          padding: 20px;
          border-radius: 8px;
        }

        .title {
          text-align: center;
          color: #005487;
          margin-bottom: 15px;
        }

        .search-box {
          display: flex;
          gap: 10px;
          justify-content: flex-start;
          margin-bottom: 20px;
        }

        .search-box input {
          padding: 8px 12px;
          border: 1px solid #d1d5db;
          border-radius: 6px;
          width: 250px;
        }

        .search-box button {
          padding: 8px 18px;
          background: #005487;
          color: #fff;
          border: none;
          border-radius: 6px;
          cursor: pointer;
        }

        .search-box button:hover {
          background: #005487;
        }

        .tracking-table {
          width: 100%;
          border-collapse: collapse;
          font-size: 13px;
        }

        .tracking-table th,
        .tracking-table td {
          padding: 10px;
          border-bottom: 1px solid #e5e7eb;
          text-align: center;
        }

        .tracking-table thead {
          background: #f3f4f6;
        }

        .tracking-table tr:nth-child(even) {
          background: #fafafa;
        }

        .view-link {
          color: #2563eb;
          cursor: pointer;
          font-weight: 500;
        }

        .view-link:hover {
          text-decoration: underline;
        }

        .status {
          font-weight: 600;
          color: #15803d;
        }
          .modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.modal-box {
  background: #fff;
  width: 80%;
  max-height: 85vh;
  overflow: auto;
  border-radius: 8px;
  padding: 15px;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.items-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}

.items-table th,
.items-table td {
  border: 1px solid #ddd;
  padding: 8px;
  font-size: 14px;
}

.items-table th {
  background: #f5f5f5;
}

.total-box {
  margin-top: 15px;
  text-align: right;
}

.grand-total {
  font-size: 16px;
  font-weight: bold;
  color: #0a7c2f;
}/* BILLING CARD */
.billing-card {
  background: #fff;
  border-radius: 10px;
  padding: 15px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  margin-top: 15px;
}

.bill-row {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px dashed #e0e0e0;
  font-size: 14px;
}

.bill-row:last-child {
  border-bottom: none;
}

.bill-row.discount span:last-child {
  color: #d32f2f;
}

.bill-row.grand {
  font-size: 16px;
  font-weight: bold;
  color: #0a8f3c;
}

/* ORDER META */
.order-meta {
  margin: 15px 0;
  font-size: 13px;
  color: #555;
}

/* TRACKER */
.order-tracker {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 0;
  position: relative;
}

.order-tracker::before {
  content: "";
  position: absolute;
  top: 20px;
  left: 0;
  right: 0;
  height: 4px;
  background: #ddd;
  z-index: 0;
}

.tracker-step {
  text-align: center;
  z-index: 1;
  width: 20%;
}

.tracker-step .circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #ccc;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 6px;
  font-weight: bold;
}

.tracker-step.active .circle {
  background: #2e7d32;
}

.tracker-step p {
  font-size: 12px;
  color: #555;
}

/* CLOSE BUTTON */
.close-btn {
  display: block;
  margin: 10px auto 0;
  background: #e53935;
  color: #fff;
  border: none;
  padding: 8px 30px;
  border-radius: 6px;
  cursor: pointer;
  fontsize:12px
}

.pagination-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  flex-wrap: wrap;
  gap: 12px;
}

.pagination-info {
  display: flex;
  align-items: center;
  gap: 16px;
  color: #475569;
  font-size: 13px;
}

.pagination-info select {
  padding: 6px 32px 6px 12px;
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  font-size: 13px;
  color: #1e293b;
  background: #ffffff;
  cursor: pointer;
}

.page-buttons {
  display: flex;
  align-items: center;
  gap: 8px;
}

.page-btn {
  padding: 7px 16px;
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  color: #1e293b;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
}

.page-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.page-count {
  padding: 6px 14px;
  font-size: 13px;
  font-weight: 500;
  color: #1e293b;
  background: #f1f5f9;
  border-radius: 6px;
  min-width: 48px;
  text-align: center;
}


      `}</style>
    </div>
  );
};

export default TelecallingOrderTracking;
